import { createSlice } from "@reduxjs/toolkit";
import { shoppingListApi } from "@/store/shoppingListApi";

/**
 * Whether a product is on the shopper's shopping list, as last set by an add or removal in this tab.
 * A page keeps the isInShoppingList it was rendered with, and Back reuses that copy, so without this
 * a product saved or removed since then shows its old state.
 */
export interface ShoppingListMembershipSliceState {
  savedByMpId: Record<number, boolean>;
}

const initialState: ShoppingListMembershipSliceState = {
  savedByMpId: {},
};

export const shoppingListMembershipSlice = createSlice({
  name: "shoppingListMembershipSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(shoppingListApi.endpoints.addToShoppingList.matchFulfilled, (state, action) => {
        action.meta.arg.originalArgs.forEach((mpId) => {
          state.savedByMpId[mpId] = true;
        });
      })
      .addMatcher(shoppingListApi.endpoints.removeFromShoppingList.matchFulfilled, (state, action) => {
        action.meta.arg.originalArgs.forEach((mpId) => {
          state.savedByMpId[mpId] = false;
        });
      });
  },
});

export default shoppingListMembershipSlice;
